<template>
  <div class="form_item">
    <input
      v-if="type === 'color'"
      :name="name"
      :id="`form_field_${name}`"
      :required="required"
      :placeholder="placeholder"
      :class="`form_input ${extraClass}`"
      type="color"
    />
    <input
      v-else-if="type === 'date'"
      :name="name"
      :id="`form_field_${name}`"
      :required="required"
      :placeholder="placeholder"
      :class="`form_input ${extraClass}`"
      type="date"
    />
    <input
      v-else-if="type === 'datetime-local'"
      :name="name"
      :id="`form_field_${name}`"
      :required="required"
      :placeholder="placeholder"
      :class="`form_input ${extraClass}`"
      type="datetime-local"
    />
    <input
      v-else-if="type === 'email'"
      :name="name"
      :id="`form_field_${name}`"
      :required="required"
      :placeholder="placeholder"
      :class="`form_input ${extraClass}`"
      type="email"
    />
    <input
      v-else-if="type === 'file'"
      :name="name"
      :id="`form_field_${name}`"
      :required="required"
      :placeholder="placeholder"
      :class="`form_input ${extraClass}`"
      type="file"
    />
    <input
      v-else-if="type === 'hidden'"
      :name="name"
      :id="`form_field_${name}`"
      :required="required"
      :placeholder="placeholder"
      :class="`form_input ${extraClass}`"
      type="hidden"
    />
    <input
      v-else-if="type === 'month'"
      :name="name"
      :id="`form_field_${name}`"
      :required="required"
      :placeholder="placeholder"
      :class="`form_input ${extraClass}`"
      type="month"
    />
    <input
      v-else-if="type === 'number'"
      :name="name"
      :id="`form_field_${name}`"
      :required="required"
      :placeholder="placeholder"
      :class="`form_input ${extraClass}`"
      type="number"
    />
    <input
      v-else-if="type === 'password'"
      :name="name"
      :id="`form_field_${name}`"
      :required="required"
      :placeholder="placeholder"
      :class="`form_input ${extraClass}`"
      type="password"
    />
    <input
      v-else-if="type === 'range'"
      :name="name"
      :id="`form_field_${name}`"
      :required="required"
      :placeholder="placeholder"
      :class="`form_input ${extraClass}`"
      type="range"
    />
    <input
      v-else-if="type === 'tel'"
      :name="name"
      :id="`form_field_${name}`"
      :required="required"
      :placeholder="placeholder"
      :class="`form_input ${extraClass}`"
      type="tel"
    />
    <input
      v-else-if="type === 'time'"
      :name="name"
      :id="`form_field_${name}`"
      :required="required"
      :placeholder="placeholder"
      :class="`form_input ${extraClass}`"
      type="time"
    />
    <input
      v-else-if="type === 'url'"
      :name="name"
      :id="`form_field_${name}`"
      :required="required"
      :placeholder="placeholder"
      :class="`form_input ${extraClass}`"
      type="url"
    />
    <input
      v-else-if="type === 'week'"
      :name="name"
      :id="`form_field_${name}`"
      :required="required"
      :placeholder="placeholder"
      :class="`form_input ${extraClass}`"
      type="week"
    />
    <input
      v-else
      :name="name"
      :id="`form_field_${name}`"
      :required="required"
      :placeholder="placeholder"
      :class="`form_input ${extraClass}`"
      type="text"
    />
  </div>
</template>

<script>
export default {
  name: 'FormInput',
  props: {
    type: {
      default: 'text',
      required: false,
      type: String
    },
    name: {
      default: 'text',
      required: true,
      type: String
    },
    required: {
      default: false,
      required: false,
      type: Boolean
    },
    placeholder: {
      default: '',
      required: false,
      type: String
    },
    extraClass: {
      default: '',
      required: false,
      type: String
    }
  }
}
</script>
